import apiClient from "../utils/axios";
import { API_CONFIG } from "../config/api";

const E = API_CONFIG.ENDPOINTS;
const post = async (url, body = {}) => (await apiClient.post(url, body)).data;

export const familyService = {
  login: (email, password) => post(E.LOGIN, { email, password }),
  verify: () => post(E.VERIFY),
  register: (data) => post(E.REGISTER, data),
  setPassword: (token, password) => post(E.SET_PASSWORD, { token, password }),
  requestReset: (email) => post(E.REQUEST_RESET, { email }),
  getCentres: () => post(E.CENTRES),
  getPortalSettings: () => post(E.PORTAL_SETTINGS),

  getHandbook: () => post(E.HANDBOOK),
  getForms: () => post(E.FORMS),
  getDocuments: () => post(E.DOCUMENTS),
  getPolicies: () => post(E.POLICIES),
  getChildren: () => post(E.CHILDREN),
  getSubmissions: () => post(E.SUBMISSIONS),
  getHolidayBalance: (child_id) => post(E.HOLIDAY_BALANCE, { child_id }),
  submitForm: (payload) => post(E.SUBMIT_FORM, payload),
  updateProfile: (data) => post(E.UPDATE_PROFILE, data),
  changePassword: (current_password, new_password) =>
    post(E.CHANGE_PASSWORD, { current_password, new_password }),
  getNotifications: () => post(E.NOTIFICATIONS),
  updateNotifications: (prefs) => post(E.UPDATE_NOTIFICATIONS, { prefs }),
};
